module.exports = __webpack_public_path__ + "static/img/iconfont.1706dd64.svg";